// src/components/Inv-Tracker/api/invTrackerApi.js
// ============================================================================
// BLOCK ITR.API.001 — Inventory Tracker API client
// ----------------------------------------------------------------------------
// PURPOSE
// - Centralizes feature-local HTTP requests.
// - Keeps axios URL details out of the page shell and controller.
// ============================================================================

import axios from '../../../axiosClient.js';

// ============================================================================
// BLOCK ITR.API.001.01 — Primitive helpers
// ----------------------------------------------------------------------------
// PURPOSE
// - Normalize simple payload pieces before requests are sent.
// ============================================================================
function trimStr(value) {
  return String(value ?? '').trim();
}

// ============================================================================
// BLOCK ITR.API.001.02 — Read queries
// ----------------------------------------------------------------------------
// PURPOSE
// - Load reference dates for the top filter bar.
// - Load the main tree payload.
// ============================================================================
export async function fetchReferenceDates(params = {}) {
  const { data } = await axios.get('/api/inv-tracker/reference-dates', { params });

  return Array.isArray(data?.reference_dates) ? data.reference_dates : [];
}

export async function fetchInventoryTransactions(params = {}) {
  const { data } = await axios.get('/api/inv-tracker/transactions', { params });

  return {
    referenceDate: trimStr(data?.reference_date),
    items: Array.isArray(data?.items) ? data.items : [],
    totalSourceRows: Number(data?.total_source_rows ?? 0),
    totalVisibleRows: Number(data?.total_visible_rows ?? 0),
    statusCounts: data?.status_counts || { open: 0, follow_up: 0, cleared: 0 },
  };
}

// ============================================================================
// BLOCK ITR.API.001.03 — Mutation queries
// ----------------------------------------------------------------------------
// PURPOSE
// - Persist review-state changes for selected rows.
// ============================================================================
export async function updateReviewRows(payload) {
  const { data } = await axios.post('/api/inv-tracker/review-rows', payload);
  return data;
}
